<template>
  <div class="page-container">
    <div class="page-card">
      <div class="page-card__header">
        <h1 class="section-title">公益项目</h1>
      </div>
      <div class="page-card__body">
        <div v-for="row in tableData" :key="row.id" class="article-row">
          <a :href="row.linkUrl" target="_blank" class="article-row__title">{{ row.title }}</a>
          <span class="article-row__date">{{ row.publishDate }}</span>
        </div>
        <div v-if="!tableData.length" class="empty-tip">暂无数据</div>
        <div class="pagination-wrap">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page="pageNo"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { charityProject } from '@/api/cmsApi'

export default {
  name: 'CharityProject',
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      charityProject({ pageNo: this.pageNo, pageSize: this.pageSize }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.total = res.data.total
        }
      })
    },
    handleCurrentChange(page) {
      this.pageNo = page
      this.query()
    }
  }
}
</script>

<style scoped>
.empty-tip {
  text-align: center;
  color: var(--color-text-muted);
  padding: 40px 0;
}
</style>
